import editorModel from '../data/editorModel';
var SITE_CREATION_TEMPLATE_ID = '6e51b1b9-0fa7-42df-9637-771a4543f4f4';
// duplicated to '@/main/startup/sectionsExperience'
export var isSiteCreationSectionsTemplate = function () {
    var originalTemplateId = editorModel.siteHeader.originalTemplateId;
    return originalTemplateId === SITE_CREATION_TEMPLATE_ID;
};
